import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, Card, CardHeader, CardContent, Icon, List, ListItem, ListItemText, ListItemSecondaryAction, IconButton} from '@material-ui/core'
import {compose} from 'redux'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import autobind from 'autobind-decorator'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer'
import { CtxCotation, withCotation } from 'src/page/Consumer/Cotation/CotationProvider'
import { updateCotation, getUsersToNotify, getUsersNotify } from 'src/core/redux/action/cotationAction'
import { withRouter, RouteComponentProps } from 'react-router'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { withToast } from 'src/shared/Toast'
import { WithToast } from 'src/type/lib/withToast'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import InputAutocomplete from 'src/shared/InputAutocomplete/InputAutocomplete'
import {debounce} from 'lodash'
import { IUser } from 'src/type/user'
import { getUserBestName } from 'src/shared/utils/helpers'

const styles = (t: Theme) => createStyles({
    card: {
        height: '100%',
        marginBottom: t.spacing.unit * 2
    },
    cardTitle: {fontSize: '1.2rem',textTransform: 'uppercase'},
});

interface IProps extends WithI18n,
  WithToast,
  WithGlobalProgress,
  RouteComponentProps<any>,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>,
  CtxCotation {
}

interface IState{
  users: IUser[];
  userNotifyResult: IUser[];
}
class Notification extends React.Component<IProps, IState> {
  state = {
    users: [] as IUser[],
    userNotifyResult: [] as IUser[]
  }

  render() {
    const {t, classes} = this.props;
    const {users} = this.state;
    
    return (
        <Card className={classes.card}>
            <CardHeader classes={{title: classes.cardTitle}}  title={
              <div style={{display: 'flex', alignItems: 'center'}}>
                <Icon style={{marginRight: '5px'}}>add_alert</Icon>
                {t.Cotation_notified_people}
              </div>
            }/>
            <CardContent style={{overflow: 'visible'}}>
                <InputAutocomplete
                    data={this.renderUserData()}
                    onChange={debounce(text => this.onUserNotifySearchChange(text), 500)}
                    onSelect={this.onSelectUser}
                    withoutFilter
                    placeholder={t.search}
                />
                <br/>
                {users && users.length > 0 &&
                  <List dense={false}>
                    {users.map((u, i) => (
                      <ListItem key={`user-to-notify-${i}`} style={{paddingLeft: 0}}>
                        <ListItemText
                          primary={getUserBestName(u)}
                          secondary={u.email}
                          style={{paddingBottom: 0, marginBottom: '8px'}}
                        />
                        <ListItemSecondaryAction>
                          <IconButton aria-label="Supprimer" onClick={() => this.removeUser(u.id)}>
                            <Icon>delete</Icon>
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                }
            </CardContent>
        </Card>
    )
  }

  componentDidUpdate(prevProps){
    const {detail} = this.props
    if (prevProps.detail !== detail && detail && detail.users_to_notify_ids) {
      this.props.fetch(detail.users_to_notify_ids).then(res => this.setState({users: res}))
    }
  }

  @autobind
  private removeUser(id: string) {
    const {detail, match, toastSuccess, toastError, t} = this.props
    if(detail){
      const data = this.state.users.filter(x => x.id !== id).map(u => u.id)
      this.props.updateCotation({cotation: {users_to_notify_ids: data && data.length > 0 ? data.join() : ''}}, match.params.productType, match.params.cotationId).then(res => {
        toastSuccess(t.action_success)
        if(res.cotation.users_to_notify_ids && res.cotation.users_to_notify_ids.length > 0){
            this.refeshAfterChange(res.cotation.users_to_notify_ids)
        } else {
            this.setState({users: [] as IUser[]})
        }
      }).catch(err => toastError(err.msg))
    }
  }

  @autobind
  private renderUserData(){
    const { userNotifyResult } = this.state;
    if(userNotifyResult){
      const r:any[] =[];
      userNotifyResult.forEach((d: IUser) => {
        d['label'] = `${getUserBestName(d)} ${(d.first_name && d.last_name) ? `(${d.email})` : ''}`;
        r.push(d);
      });
      return r;
    } else return []
  }

  @autobind
  private onSelectUser(value){
    const {detail, match, toastSuccess, toastError, t} = this.props
    if(detail && detail.users_to_notify_ids && detail.users_to_notify_ids.includes(value.id)){
        toastError('Cet utilisateur est déjà existant')
    } else {
        const userAdded = detail!.users_to_notify_ids ? detail!.users_to_notify_ids + ',' + value.id : value.id
        this.props.updateCotation({cotation: {users_to_notify_ids: userAdded}}, match.params.productType, match.params.cotationId).then(res => {
          toastSuccess(t.action_success)
            if(res.cotation.users_to_notify_ids && res.cotation.users_to_notify_ids.length > 0){
                this.refeshAfterChange(res.cotation.users_to_notify_ids)
            } else {
                this.setState({users: [] as IUser[]})
            }
        }).catch(err => toastError(err.msg))
    }
  }

  @autobind
  private onUserNotifySearchChange(text) {
    const {match} = this.props
    this.props.getUsers(match.params.productType, text).then(res => this.setState({userNotifyResult: res.data}))
  };

  @autobind
  private refeshAfterChange(ids: string){
    this.props.fetch(ids).then(res => this.setState({users: res}))
  }

}

const state2props = (state: RootState) => ({
    connectedUser: state.accountInfo.connectedUser,
})

const dispatch2props = (dispatch: any) => ({
    fetch: (ids: string) => dispatch(getUsersNotify(ids)),
    updateCotation: (data: any, productType: string, id: string) => dispatch(updateCotation(data, productType, id)),
    getUsers: (productType: string, searchText?: string) => dispatch(getUsersToNotify(productType, searchText)),
})

export default compose(
  withCotation,
  withRouter,
  withI18n,
  withGlobalProgress,
  withToast,
  withStyles(styles),
  connect(state2props, dispatch2props)
)(Notification)



// WEBPACK FOOTER //
// ./src/page/Consumer/Cotation/Notification.tsx